import api from './axiosConfig';
export const getAnalysis  = (submissionId) => api.get(`/api/v1/submissions/${submissionId}/analysis`);
export const reanalyze    = (submissionId) => api.post(`/api/v1/submissions/${submissionId}/reanalyze`);
